
const decodeBase64 = (data: string) => {
  try {
    // Convert from base64url to base64
    const base64 = data.replace(/-/g, '+').replace(/_/g, '/');
    
    // Use the native atob, then convert from Latin1 to UTF-8
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    
    // Decode as UTF-8
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(bytes);
  } catch (error) {
    console.error("Error decoding content:", error);
    return "";
  }
};

export const extractAttachments = (messageData: any) => {
  if (!messageData?.payload) return [];
  const attachments: any[] = [];
  
  // Function to recursively search parts for attachments
  const searchAttachments = (parts: any[]) => {
    if (!parts) return;
    
    parts.forEach(part => {
      // Check if part is an attachment
      if (part.filename && part.filename.trim() !== '') {
        attachments.push({
          id: part.body.attachmentId,
          filename: part.filename,
          mimeType: part.mimeType,
          size: part.body.size || 0,
          messageId: messageData.id
        });
      }
      
      // Recursively search nested parts
      if (part.parts) {
        searchAttachments(part.parts);
      }
    });
  };
  
  // Start searching from the top level payload
  if (messageData.payload.parts) {
    searchAttachments(messageData.payload.parts);
  }
  
  return attachments;
};

export const processMessageContent = (messageData: any) => {
  if (!messageData?.payload) return { htmlContent: "", content: "" };
  let htmlContent = "";
  let content = "";
  
  if (messageData.payload.parts) {
    const htmlPart = messageData.payload.parts.find((part: any) => part.mimeType === "text/html");
    if (htmlPart?.body?.data) {
      htmlContent = decodeBase64(htmlPart.body.data);
    }

    if (!htmlContent) {
      const textPart = messageData.payload.parts.find((part: any) => part.mimeType === "text/plain");
      if (textPart?.body?.data) {
        content = decodeBase64(textPart.body.data);
      }
    }
  } else if (messageData.payload.body?.data) {
    const rawContent = decodeBase64(messageData.payload.body.data);
    if (messageData.payload.mimeType === "text/html") {
      htmlContent = rawContent;
    } else {
      content = rawContent;
    }
  }

  return { htmlContent, content };
};

export const extractEmailDetails = (messageData: any) => {
  if (!messageData?.payload?.headers) {
    return {
      subject: "No Subject",
      sender: "Unknown Sender",
      preview: "",
      date: new Date().toLocaleDateString(),
      content: "",
      htmlContent: "",
      attachments: []
    };
  }

  const headers = messageData.payload.headers;
  const subject = headers.find((h: { name: string }) => h.name === "Subject")?.value || "No Subject";
  const from = headers.find((h: { name: string }) => h.name === "From")?.value || "Unknown Sender";
  const date = headers.find((h: { name: string }) => h.name === "Date")?.value || "";
  const preview = messageData.snippet || "";

  const { htmlContent, content } = processMessageContent(messageData);
  const attachments = extractAttachments(messageData);

  return {
    subject,
    sender: from,
    preview,
    date: new Date(date).toLocaleDateString(),
    content,
    htmlContent,
    attachments
  };
};
